import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { MDBDataTable } from "mdbreact";
import { CSVLink } from "react-csv";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { dateFormat, timeFormat } from '../../../../dynamicController';
import Loading from '../Loading';
import { DatePicker, Select } from "antd";
import dayjs from 'dayjs';

const mySwal = withReactContent(Swal);
const { RangePicker } = DatePicker;

const ReferralRewardHistoryReportCard = ({ token, role, operators, distributors, stamp, etoken, point }) => {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [startDate, setStartDate] = useState(dayjs().startOf('month'));
    const [endDate, setEndDate] = useState(dayjs().endOf('month'));
    const [operatorId, setOperatorId] = useState(null)
    const [distributorId, setDistributorId] = useState(null)
    const [operatorOption, setOperatorOpion] = useState([])
    const [distributorOption, setDistributorOption] = useState([])

    useEffect(() => {
        if (operators) {
            let operatorList = []
            for (let i = 0; i < operators.length; i++) {
                let operatorObject = {
                    value: operators[i].id,
                    label: operators[i].username
                }
                operatorList.push(operatorObject)
            }
            setOperatorOpion(operatorList)
        }
    }, [operators])

    useEffect(() => {
        if (distributors) {
            let distributorList = []
            for (let i = 0; i < distributors.length; i++) {
                let distributorObject = {
                    value: distributors[i].id,
                    label: distributors[i].name
                }
                distributorList.push(distributorObject)
            }
            setDistributorOption(distributorList)
        }
    }, [distributors])

    useEffect(() => {
        if (role !== "client") {
            setLoading(true)
            axios
                .post("/api/admin/report/referralRewardHistoryReport", { startDate, endDate }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setData(res.data.data)
                    setLoading(false)
                })
                .catch(err => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error")
                });
        }
    }, [])

    const handleDate = (dates, dateStrings) => {
        if (dates) {
            setStartDate(dateStrings[0])
            setEndDate(dateStrings[1])
        } else {
            setStartDate("")
            setEndDate("")
        }
    };

    const handleFilter = () => {
        if (role === "client" && !distributorId && !operatorId) {
            mySwal.fire(t("Error"), t("Please select distributor or operator"), "error");
        } else {

            setLoading(true)

            axios
                .post("/api/admin/report/referralRewardHistoryReport", { startDate, endDate, operatorId, distributorId }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setData(res.data.data)
                    setLoading(false)
                })
                .catch(err => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error")
                });
        }
    }

    const handleReset = () => {
        setStartDate(dayjs().startOf('month'))
        setEndDate(dayjs().endOf('month'))
        setData([])
        setOperatorId(null)
        setDistributorId(null)

        if (role !== "client") {
            setLoading(true)

            axios
                .post("/api/admin/report/referralRewardHistoryReport", { startDate: dayjs().startOf('month').format("YYYY-MM-DD"), endDate: dayjs().endOf('month').format("YYYY-MM-DD") }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setData(res.data.data)
                    setLoading(false)
                })
                .catch(err => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error")
                });
        }
    }

    const handleChangeDistributor = (value) => {
        setDistributorId(value)
        setOperatorId(null)
    }

    const handleChangeOperator = (value) => {
        setOperatorId(value)
        setDistributorId(null)
    }

    let dataTable = {
        columns: [
            {
                label: t("Date"),
                field: "date",
                sort: "asc"
            },
            {
                label: t("Reward To"),
                field: "reward_to",
                sort: "asc"
            },
            {
                label: t("Reward From"),
                field: "reward_from",
                sort: "asc"
            },
            {
                label: t("Transaction Account"),
                field: "transaction_account",
                sort: "asc"
            },
            {
                label: t("Tier"),
                field: "tier",
                sort: "asc"
            },
            {
                label: t("Voucher"),
                field: "voucher",
                sort: "asc"
            },
        ],
        rows: data
    };

    const csvData = {
        headers: [
            { label: "Date", key: "date" },
            { label: "Reward To", key: "reward_to" },
            { label: "Reward From", key: "reward_from" },
            { label: "Transaction Account", key: "transaction_account" },
            { label: "Tier", key: "tier" },
            { label: "Voucher", key: "voucher" },
        ],
        data: data
    };

    if (stamp) {
        dataTable.columns.push(
            {
                label: t("Washer Stamp"),
                field: "washer_stamp",
                sort: "asc"
            },
            {
                label: t("Dryer Stamp"),
                field: "dryer_stamp",
                sort: "asc"
            }
        )

        csvData.headers.push(
            { label: "Washer Stamp", key: "washer_stamp" },
            { label: "Dryer Stamp", key: "dryer_stamp" },
        )
    }

    if (etoken) {
        dataTable.columns.push(
            {
                label: t("Token"),
                field: "token",
                sort: "asc"
            },
        )

        csvData.headers.push(
            { label: "Token", key: "token" },
        )
    }

    if (point) {
        dataTable.columns.push(
            {
                label: t("Point"),
                field: "point",
                sort: "asc"
            },
        )

        csvData.headers.push(
            { label: "Point", key: "point" },
        )
    }

    return (
        <div className="card">
            <div className="card-header">
                <h5 className="card-title">{t("Referral Reward History Report")}</h5>
            </div>

            <div className="card-body">
                <div className="mb-5">
                    <h6>{t("Filter")}</h6>
                    {
                        role === "client" ? (
                            <div className="mb-3">
                                <label htmlFor="distributorId">{t("Select Distributor")}: </label>
                                <Select
                                    id="distributorId"
                                    name="distributorId"
                                    allowClear
                                    style={{ width: '100%' }}
                                    placeholder={t("Select Distributor")}
                                    showSearch
                                    optionFilterProp="label"
                                    onChange={(value) => handleChangeDistributor(value)}
                                    options={distributorOption}
                                    value={distributorId}
                                />
                            </div>
                        ) : null
                    }

                    {
                        role === "client" ? (
                            <div className="mb-3">
                                <label htmlFor="operatorId">{t("Select Operator")}: </label>
                                <Select
                                    id="operatorId"
                                    name="operatorId"
                                    allowClear
                                    style={{ width: '100%' }}
                                    placeholder={t("Select Operator")}
                                    showSearch
                                    optionFilterProp="label"
                                    onChange={(value) => handleChangeOperator(value)}
                                    options={operatorOption}
                                    value={operatorId}
                                />
                            </div>
                        ) : null
                    }

                    <div className="mb-3">
                        <label htmlFor="date">{t("Select Date")}: </label>
                        <RangePicker
                            id="date"
                            name="date"
                            placeholder={[t("Start date"), t("End date")]}
                            onChange={handleDate}
                            style={{ width: '100%' }}
                            value={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : []}
                            allowClear={false}
                            presets={[
                                { label: t("Today"), value: [dayjs(), dayjs()] },
                                { label: t("Yesterday"), value: [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')] },
                                { label: t("Last 7 Days"), value: [dayjs().subtract(6, 'day'), dayjs()] },
                                { label: t("Last 30 Days"), value: [dayjs().subtract(29, 'day'), dayjs()] },
                                { label: t("This Month"), value: [dayjs().startOf('month'), dayjs().endOf('month')] },
                                { label: t("Last Month"), value: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')] }
                            ]}
                        />
                    </div>

                    <div className="d-flex">
                        <button onClick={() => handleFilter()} className="btn btn-primary btn-inline form-control me-3">
                            {t("Filter")}
                        </button>
                        <button onClick={() => handleReset()} className="btn btn-secondary btn-inline form-control ms-3">
                            {t("Reset")}
                        </button>
                    </div>
                </div>
                <div className="text-center mt-5">
                    {
                        loading ? <Loading /> : (
                            <div>
                                <MDBDataTable data={dataTable} noBottomColumns striped hover responsive bordered />
                                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <CSVLink className="btn btn-primary" data={csvData.data} headers={csvData.headers} filename={`referral_reward_history_report_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                        {t("Download Report")}
                                    </CSVLink>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default ReferralRewardHistoryReportCard;